import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";

export const fetchCoreValues = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/our-core-values`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};
